<div class="container-fluid">

  <app-content-tab-list activeTab="0" type="cms" category="CMS"></app-content-tab-list>

  <div class="row section1 mt-4">
    <div class="col-12 col-md-7">
      <div class="home-details">
        <h5 class="home-title">Banners</h5>
        <p class="home-subtitle">Add new banner for the occasion</p>
      </div>
    </div>
  </div>
  <div class="section1">
    <div class="applicants-details details1">
      <form class="admin-form" enctype="multipart/form-data">
        <div class="row ">
          <div class="col-auto job-form">
            <div class="row ">
              <div class="col-12 ">
                <div class="user-form">
                  <div class="form-group d-flex flex-column">
                    <label>Profile Picture*</label>
                    <img class="position-relative " style="object-fit: cover" width="500"
                      height="250"
                      src="assets/images/placeholder.png" alt="">
                      @if (!loading) {
                        <i (click)="handleClickUpload()"
                        class="las font-size-16 la-plus-circle img-icon banner"></i>
                      }
                      @if (loading) {
                        <div class="img-icon-loader banner-img">
                          <img src="assets/images/loading.gif" width="55" alt="">
                        </div>
                      }
                    </div>
                    <input id="dp" name="file-upload-field" type="file"
                      accept=".png, .jpg, .jpeg, .webp"
                      class="form-control d-none"
                      (change)="fileChangeEvent($event, imageCropperModal, 'BANNER')" required>
                  </div>
                </div>
              </div>
            </div>
            <div class="col job-form ml-3">
              <div class="row">
                <div class="user-form">
                  <div class="form-group">
                    <label>Read once before uploading</label>
                    <li>The image should be of ratio <span class="font-weight-bold">2:1</span>.</li>
                    <li>Preferably <span class="font-weight-bold">Height - 400px </span> and <span class="font-weight-bold"> Width - 800px</span>.</li>
                    <li>File Format - <span class="font-weight-bold"> JPG / JPEG / PNG</span></li>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>
            <div class="home-details mb-3">
              <h5 class="home-title">Uploaded banners</h5>
              <p class="home-subtitle">List of all uploaded banners</p>
            </div>
            <div class="row">
              @for (b of bannersList; track b; let i = $index) {
                <div class="col-auto">
                  <div class=" position-relative text-danger">
                    <img src="{{b.imagePath}}" alt="banner-{{i}}" width="500" class="img-fluid ">
                    @if (!loading) {
                      <i (click)="deleteBanner(i)"
                      class="las font-size-16 la-trash img-icon banner-img"></i>
                    }
                  </div>
                  <hr>
                  </div>
                }
              </div>

            </form>
          </div>
        </div>
      </div>

      <ng-template #imageCropperModal>
        <div class="modal-header">
          <h5 class="modal-title">Add icon</h5>
          <button type="button" class="close " data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true" class="">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <image-cropper
            (imageCropped)="imageCropped($event)"
            (loadImageFailed)="loadImageFailed()"
            [aspectRatio]=aspectRatio
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            format="png">
          </image-cropper>
        </div>
        <div class="modal-footer justify-content-end">
          <button type="button" class="btn btn-default mr-2" data-dismiss="modal" (click)="modalRef.hide()">Close</button>
          <button (click)="uploadImage(this.croppedFile); modalRef.hide()" class="btn btn-primary btn-dashboard" type="button">Crop
          </button>
        </div>
      </ng-template>
